import { useMemo, useState } from 'react'
import {
  definirAssocAreasAhPartirOrdemCarregamento,
  getPlacasPrevistaCarregamentoByPickingId,
} from '../../../../services/api/https/deliveries/importation.http'

const INIT_STATE = {
  loading: true,
  btnLoading: false,
  placas: [],
  errorMessage: null,
  successMessage: null,
  navigateBack: false,
  addBadgeToAreaNickname: false,
  addInfoComplementarToAreaNickname: false,
}

export default function useAssAreaPlacaPrevistaCarregamento() {
  const [state, setState] = useState({ ...INIT_STATE })

  const localDispatcher = useMemo(() => {
    return {
      async fetchPlacas(pickingId) {
        const placas = await getPlacasPrevistaCarregamentoByPickingId(pickingId)
        setState(prevState => ({
          ...prevState,
          loading: false,
          placas: placas.map(p => ({ ...p, ordem: '' })),
        }))
      },

      onOrdemChange(placaRow, ordem) {
        setState(prev => {
          const index = prev.placas.findIndex(p => p.placa === placaRow.placa)
          if (index !== -1) {
            prev.placas[index].ordem = ordem
          }
          return { ...prev }
        })
      },

      async associarAreas(
        placasRows,
        pickingId,
        addBadgeToAreaNickname,
        addInfoComplementarToAreaNickname,
      ) {
        try {
          setState(prevState => ({ ...prevState, btnLoading: true }))

          const placasSemOrdemCarregamento = []
          const ordensDigitadas = []
          const ordensDuplicadas = []

          placasRows.forEach(r => {
            const ordem = Number(r.ordem)
            if (ordem === 0) {
              placasSemOrdemCarregamento.push(r.placa)
            } else {
              if (ordensDigitadas.some(od => od === ordem)) {
                ordensDuplicadas.push(ordem)
              } else {
                ordensDigitadas.push(ordem)
              }
            }
          })

          if (placasSemOrdemCarregamento.length > 0) {
            setState(prevState => ({
              ...prevState,
              btnLoading: false,
              errorMessage: `As seguintes placas não possuem Ordem de Carregamento digitada: ${placasSemOrdemCarregamento.join(', ')}`,
            }))
          } else if (ordensDuplicadas.length > 0) {
            setState(prevState => ({
              ...prevState,
              btnLoading: false,
              errorMessage: `As seguintes Ordens de Carregamento estão duplicadas: ${ordensDuplicadas.join(', ')}`,
            }))
          } else {
            await definirAssocAreasAhPartirOrdemCarregamento(
              placasRows.map(pr => ({ placa: pr.placa, ordem_carregamento: Number(pr.ordem) })),
              pickingId,
              addBadgeToAreaNickname,
              addInfoComplementarToAreaNickname,
            )

            setState(prevState => ({ ...prevState, btnLoading: false, navigateBack: true }))
          }
        } catch (e) {
          setState(prevState => ({
            ...prevState,
            loading: false,
            errorMessage: e,
            btnLoading: false,
          }))
        }
      },

      resetMessages() {
        setState(prev => ({ ...prev, errorMessage: null, successMessage: null }))
      },

      toggleAddBadgeToAreaNickname() {
        setState(prev => ({ ...prev, addBadgeToAreaNickname: !prev.addBadgeToAreaNickname }))
      },
      toggleAddInfoComplementarToAreaNickname() {
        setState(prev => ({
          ...prev,
          addInfoComplementarToAreaNickname: !prev.addInfoComplementarToAreaNickname,
        }))
      },
    }
  }, [])

  return { state, localDispatcher }
}
